export class ChatDialog {
  chatDialogId: string;
  enterpriseId: number;
  shipmentId: number;
  occupants: string;
}
